var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.overflow)?_c('el-tooltip',{attrs:{"effect":"dark","placement":_vm.placement,"content":_vm.content}},[_c('span',{ref:"text",staticClass:"text"},[_vm._v(" "+_vm._s(_vm.content)+" ")])]):_c('span',{ref:"text",staticClass:"text"},[_vm._v(" "+_vm._s(_vm.content)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }